import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import BoxSections from './BoxSections'
import ContentDiv from './ContentDiv'
import HeroSections from './HeroSections'
import KeyFeature from './KeyFeature'
import { Helmet } from 'react-helmet'
export default function WebDevPageIndex(props) {
    const { nft_slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [nft_slug])
    // =========================== scroll To Top default =========================
    return (
        <>
            <Helmet>
                <title>Best Web Development Company – Infograins</title>
                <meta name="description" content="We are one of the best web development companies offering custom web solutions for your brand." />
            </Helmet>
            <HeroSections />
            <BoxSections />
            <ContentDiv />
        </>
    )
}
